import angular from 'angular'
import templateSettingCtrl from './templateSettingCtrl.js'
import templateModalCtrl from './templateModalCtrl.js'
import templateDetailCtrl from './templateDetailCtrl.js'

import templateSetting from './view/templateSetting.html'

export default angular
    .module('system.settingcenter.templateSetting', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('system.settingcenter.templateSetting', {
                url: '/templateSetting',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'system.settingcenter.templateSetting.list',
                title: '申报模版',
            })
            .state('system.settingcenter.templateSetting.list', {
                url: '/list',
                template: templateSetting,
                controller: 'templateSettingCtrl',

            })
            .state('system.settingcenter.templateSetting.detail', {
                url: '/detail/:obj',
                template: require('./view/templateDetail.html'),
                controller: 'templateDetailCtrl',
                title: '申报表详情',
            })
    }])
    .controller('templateSettingCtrl', templateSettingCtrl)
    .controller('templateModalCtrl', templateModalCtrl)
    .controller('templateDetailCtrl', templateDetailCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetting/index.js